import {
  IConfig,
  IConfigContact,
  IConfigSecurity,
  IConfigSecurityDetail,
  IConfigUploader
} from '@shared/interface/config.interface';

/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Main DTO
 */
export class ConfigDto implements IConfig {
  public uploader?: IConfigUploader = new ConfigUploaderDto();
  public security?: IConfigSecurity = new ConfigSecurityDto();
  public contact?: IConfigContact = new ConfigContactDto();

  constructor(init?: Partial<any>) {
    (Object as any).assign(this, init);
  }
}

/**
 * DTO for uploader
 */
export class ConfigUploaderDto implements IConfigUploader {
  public fileTypes?: string = undefined;
  public unauthorizedFileTypes?: string = undefined;
  public maxFileSize?: number = undefined;
  public profileMaxFileSize?: number = undefined;
}

/**
 * DTO for security
 */
export class ConfigSecurityDto implements IConfigSecurity {
  public username?: ConfigSecurityDetailDto = new ConfigSecurityDetailDto();
  public password?: ConfigSecurityDetailDto = new ConfigSecurityDetailDto();
  public secretCode?: ConfigSecurityDetailDto = new ConfigSecurityDetailDto();
}

export class ConfigSecurityDetailDto implements IConfigSecurityDetail {
  public authCar?: string;
  public min?: number;
  public max?: number;
}

/**
 * DTO for contact
 */
export class ConfigContactDto implements IConfigContact {
  public subjects?: string[] = [];
}
